"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locale = void 0;
var lodash_1 = __importDefault(require("lodash"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var logger_1 = require("../utils/logger");
var config_1 = require("./config");
var convert_1 = require("./convert");
var service_1 = require("./service");
var types_1 = require("./types");
var LOCALE_KEY = "---uniform-setting-locale";
var Locale = /** @class */ (function () {
    function Locale(gConfig, config) {
        var _this = this;
        this.gConfig = gConfig;
        this.getFallback = function () {
            var lang = navigator.language || navigator.userLanguage;
            var fallback = 'en';
            if (lang) {
                fallback = convert_1.normalizeLang(lang);
            }
            if (fallback && _this.Supports.includes(fallback)) {
                return fallback;
            }
            var oldFallback = fallback;
            fallback = _this.replaceLanguage(fallback);
            _this._logger.log('getFallback:replaceLang ', oldFallback, 'to', fallback);
            if (fallback) {
                return fallback;
            }
            if (_this.gConfig.IsCN) {
                return 'cn';
            }
            return 'en';
        };
        this.getLocale = function () {
            // 阻止同时请求
            if (_this._fetchTask) {
                _this._logger.log('getLocale:use same task:', _this._fetchTask);
                return _this._fetchTask;
            }
            var cacheLocale = _this._cacheLocalData.get();
            if (cacheLocale) {
                _this._logger.log('getLocale:use cache result:', cacheLocale);
                return Promise.resolve(cacheLocale);
            }
            var user_locale = js_cookie_1.default.get(LOCALE_KEY);
            if (user_locale) {
                if (!_this.Supports.includes(user_locale)) {
                    var old_user_locale = user_locale;
                    // 替换逻辑
                    user_locale = _this.replaceLanguage(user_locale);
                    _this._logger.info('getLocale:user_locale replace', old_user_locale, 'to', user_locale);
                }
                var default_locale = _this.getFallback();
                var result = {
                    default: default_locale,
                    user: user_locale
                };
                return Promise.resolve(result);
            }
            _this._fetchTask = _this._service.fetchLocale().catch(function (e) {
                _this._logger.info('fetchLocale failed', e);
                return undefined;
            }).then(function (user_locale) {
                if (user_locale) {
                    // flush cookie
                    js_cookie_1.default.set(LOCALE_KEY, user_locale, {
                        path: '/',
                        expires: 365 * 2,
                        domain: _this.gConfig.CookieDomain,
                        sameSite: 'Lax',
                    });
                }
                if (!_this.Supports.includes(user_locale)) {
                    var old_user_locale = user_locale;
                    // 替换逻辑
                    user_locale = _this.replaceLanguage(user_locale);
                    _this._logger.info('getLocale:user_locale replace', old_user_locale, 'to', user_locale);
                }
                var default_locale = _this.getFallback();
                var result = {
                    default: default_locale,
                    user: user_locale
                };
                _this._cacheLocalData.set(result);
                var task = Promise.resolve();
                if (!user_locale) {
                    _this._logger.info('getLocale:write default locale');
                    task = _this.setLocale(default_locale);
                }
                return task.then(function () { return result; });
            }).finally(function () {
                _this._fetchTask = null;
            });
            return _this._fetchTask;
        };
        this.setLocale = function (locale) {
            if (!locale || !_this.Supports.includes(locale)) {
                _this._logger.info('setLocale invalidate Argument:', locale);
                return Promise.resolve();
            }
            var cacheLocale = _this._cacheLocalData.get();
            if (cacheLocale && cacheLocale.user !== locale) {
                _this._logger.log('setLocale:clean cache: cacheData', cacheLocale, ' newLocale:', locale);
                _this._cacheLocalData.clear();
            }
            js_cookie_1.default.set(LOCALE_KEY, locale, {
                path: '/',
                expires: 365 * 2,
                domain: _this.gConfig.CookieDomain,
                sameSite: 'Lax',
            });
            return _this._service.pushLocale(locale).catch(function (e) {
                _this._logger.info('setLocale failed', e);
            });
        };
        var loggedIn = config.loggedIn, supports = config.supports, axiosInstance = config.axiosInstance, localeService = config.localeService, verbose = config.verbose, disableHttpCache = config.disableHttpCache;
        this._config = new config_1.Config(gConfig, config);
        this._logger = new logger_1.Logger({
            module: 'uniform-setting',
            subModule: 'locale',
            verbose: verbose
        });
        this._logger.log('use config', this._config);
        if (localeService) {
            this._service = localeService;
        }
        else {
            this._service = new service_1.LocaleService(axiosInstance, this._config.BaseUrl, loggedIn, disableHttpCache);
        }
        this._cacheLocalData = this._config.makeCache();
        this._supports = supports;
    }
    Object.defineProperty(Locale.prototype, "Supports", {
        get: function () {
            if (!this._supports) {
                return types_1.LOCALES;
            }
            return this._supports;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Locale.prototype, "LoginIn", {
        get: function () {
            return this._service.LoginIn;
        },
        set: function (value) {
            this._service.LoginIn = value;
        },
        enumerable: false,
        configurable: true
    });
    // 调试用的
    Locale.prototype.changeCacheEnabled = function (enabled) {
        this._cacheLocalData.Enabled = enabled;
    };
    Locale.prototype.replaceLanguage = function (language) {
        var supports = this.Supports;
        if (lodash_1.default.size(supports) === 1) {
            return supports[0];
        }
        if (language === 'jp' && lodash_1.default.indexOf(supports, 'en') >= 0) {
            return 'en';
        }
        else if (language === 'tw' && lodash_1.default.indexOf(supports, 'cn') >= 0) {
            return 'cn';
        }
    };
    return Locale;
}());
exports.Locale = Locale;
//# sourceMappingURL=locale.js.map